module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('hackingmap', {
    on: {
      "loaded": function($event) {
        _vm.$emit('loaded')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_c('announcement'), _vm._v(" "), _c('schedule')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b022bd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Home.vue
// module id = 975
// module chunks = 1